/**
 * We do not currently design for dark mode.
 * Chakra by default does, so this is a workaround will always
 * force the 'light' color mode.
 * without this Chakra can inherit "dark" mode from a chakra localStorage key.
 *
 * @see https://chakra-ui.com/docs/styled-system/color-mode
 */
import type { StorageManager } from '@chakra-ui/color-mode';

export const staticColorMode: StorageManager = {
    type: 'localStorage',
    set: () => {
        // multiple color modes are not supported in the design
        // intentionally do nothing here.
    },
    get: () => 'light'
};
